import { purify } from "$json/lib/escape.js";
import { buttonWidget } from "$json/lib/form-widgets-definitions.js";
import { registerWidget } from "$json/lib/form-widgets.js";
import {
  ifElse,
  compose,
  hasPath,
  path,
  pathEq
} from "$json/lib/functional.js";
import { converter } from "$md-converter";

const metaThumbPath = ["metadata", "p-lightbox-thumb"];

const showThumb = hasPath(metaThumbPath);
const thumbContents = ifElse(
  pathEq(metaThumbPath, "1"),
  path(["content"]),
  path(metaThumbPath)
);

$(document).on("bb-p:control-filter", (_ev, control) => {
  if (path(["metadata", "p-lightbox"], control)) {
    control.controltype = "lightbox";
    control.content = control.value;
    control.value = path(["metadata", "p-lightbox"], control);
    if (showThumb(control)) {
      control.value = thumbContents(control) + "\n\n" + control.value;
    }
  }
});

const lightbox = Object.assign({}, buttonWidget, {
  name: "lightbox",
  attribs: (attr, control, enabled) => {
    return {
      class: showThumb(control) ? "p-lightbox-with-thumb bb-md-able" : ""
    };
  },
  onreadonly: () => {},
  afterRender: (widget, control) => {
    widget.get(0).addEventListener("click", event => {
      const btn = event.target.closest("button");
      if (btn) {
        event.preventDefault();
        const dialog = document.createElement("dialog");
        dialog.addEventListener("click", e => {
          const dialogDimensions = dialog.getBoundingClientRect();
          if (
            e.clientX < dialogDimensions.left ||
            e.clientX > dialogDimensions.right ||
            e.clientY < dialogDimensions.top ||
            e.clientY > dialogDimensions.bottom
          ) {
            dialog.close();
          }
        });
        dialog.classList.add("p-lightbox--dialog");
        const innerDiv = document.createElement("div");
        innerDiv.classList.add("p-lightbox--innerdiv");
        innerDiv.innerHTML = purify(converter.makeHtml(control.content, false));
        dialog.appendChild(innerDiv);
        document.body.appendChild(dialog);
        const closeButton = document.createElement("button");
        closeButton.classList.add("p-lightbox--dialog-close");
        const accessibleTextSpan = document.createElement("span");
        accessibleTextSpan.classList.add("a-offscreen");
        accessibleTextSpan.textContent = "sluiten";
        const inaccessibleTextSpan = document.createElement("span");
        inaccessibleTextSpan.textContent = "×";
        inaccessibleTextSpan.setAttribute("aria-hidden", true);
        closeButton.append(accessibleTextSpan, inaccessibleTextSpan);
        dialog.addEventListener("close", () => {
          dialog.remove();
        });
        closeButton.addEventListener("click", () => dialog.close());
        dialog.insertAdjacentElement("afterBegin", closeButton);
        dialog.showModal();
      }
    });
  },
  validate: () => {
    return true;
  }
});

registerWidget(lightbox);
